// extracted by mini-css-extract-plugin
module.exports = {"address":"BMap__address___31Oxq"};